import {StrategyPayloadType, PayloadType} from '@/brief-hub/store/modules/brief/types';
import isEqual from 'lodash/isEqual';
import BriefResource from '@/brief-hub/brief/BriefResource';
import {Commit} from 'vuex';
import {MutationsType} from '@/brief-hub/store/modules/brief/mutations';
import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';
import {BriefDetails} from '@/common/api/api-raw-types';
import * as RawModel from '@/common/api/api-raw-types';

const isPayloadDifferent = (payload: PayloadType | StrategyPayloadType, briefMember: RawModel.ProfileDetailsResource | BriefDetails) =>
    // @ts-ignore
    Object.keys(payload).some((prop) => !isEqual(payload[prop], briefMember[prop]));

const briefOrPayloadIsNull = () => [null, new Error('brief or payload is null')];

const updateBrief = (brief: BriefResource | null, commit: Commit) => {
    commit(MutationsType.UPDATE_BRIEF, brief);
    return [brief, null];
};

const saveAndUpdateBrief = async (saveBrief: () => Promise<HttpServiceResponse<BriefResource>>, commit: Commit) => {
    const [brief, error] = await saveBrief();
    if (brief && !error) {
        commit(MutationsType.SAVED_NOTIFICATION);
        return updateBrief(brief, commit);
    }
    return [null, error];
};

export {isPayloadDifferent, briefOrPayloadIsNull, updateBrief, saveAndUpdateBrief};
